import { isEmpty, isNil } from 'lodash';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import {
  FilterOption,
  FilterSelection,
  FilterSelectionState,
  FilterTagOption,
  FilterTagSelection,
  isFilterTagSelectionList,
  tagSelectionToTagOption,
} from '@shared/components/filter/types';
import { Pill } from '@shared/components/pill';
import { isTagComponent } from '@shared/scenes/workflows/utils';
import { i18n } from '@shared/util/i18n';

export function RenderItem({ data, negate }: { data: FilterTagOption; negate?: boolean }) {
  return (
    <Pill
      backgroundColor={data.archived ? undefined : data.backgroundColor}
      round
      sections={[data.label]}
      maxWidth={215}
      italic={data.archived}
      strikeThrough={negate}
    />
  );
}

export function MobileTagSelections({
  filter,
  selectedOptions,
}: {
  filter: FilterOption;
  selectedOptions: Map<string, FilterSelectionState>;
}) {
  const rawSelections: FilterSelection | undefined = !isNil(filter.uuid)
    ? selectedOptions.get(filter.uuid)?.selection
    : undefined;

  const tagSelections: FilterTagSelection[] = isFilterTagSelectionList(rawSelections)
    ? rawSelections
    : [];

  if (isNil(filter.component) || !isTagComponent(filter.component)) {
    return null;
  }

  if (isEmpty(tagSelections)) {
    return (
      <View>
        <Text size="body1" inactive>
          {i18n('common.selectOptions')}
        </Text>
      </View>
    );
  }

  return (
    <View row wrap>
      {tagSelections.map(selection => (
        <RenderItem key={selection.value} data={tagSelectionToTagOption(selection)} />
      ))}
    </View>
  );
}
